<template>
  <div class="page-container">
   <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">PSI分红结算</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card style="margin-top:20px">
      <div class="page-actions">
        <el-select v-model="seleCoin" filterable clearable placeholder="请选择币种">
          <el-option
            v-for="item in coinquery"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
        <el-date-picker  v-model="datePicker" type="daterange"
         :picker-options="pickerOptions0" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp"></el-date-picker>
        <el-button @click="search" type="primary">查询</el-button>
        <el-button @click="empty">清空</el-button>
      </div>
      <el-button type="primary" @click="coinAddBtn">新增币种</el-button>
      <el-button type="primary" @click="coinBtn">币种设置修改</el-button>
      <el-button type="primary" @click="exportData">导出数据</el-button>
      <el-table :data="dataList" style="margin-top:20px">
        <el-table-column prop="coin" label="币种"></el-table-column>
        <el-table-column prop="walletUserAmount" label="用户钱包"></el-table-column>
        <el-table-column prop="withWalletHot" label="提现钱包（热）" width="120"></el-table-column>
        <el-table-column prop='abrasionRatio' label="预计磨损率" width="120"> </el-table-column>
        <el-table-column prop="other" label="其他" width="120"> </el-table-column>
        <el-table-column prop="abrasion" label="钱包预计磨损" width="120"></el-table-column>
        <el-table-column prop="walletTotal" label="钱包合计"></el-table-column>
        <el-table-column prop="depositAmount" label="充值"></el-table-column>
        <el-table-column prop="withAmount" label="提现"></el-table-column>
        <el-table-column prop="specialDeposit" label="特殊充值"> </el-table-column>
        <el-table-column prop="walletDiff" label="钱包差额" width="160"></el-table-column>
        <el-table-column prop="exchangeRate" label="汇率" width="150"></el-table-column>
        <el-table-column prop="walletDiffExU" label="钱包差额折U" width="160"></el-table-column>
        <el-table-column prop="cumulateDivid" label="累计已分红" width="120"></el-table-column>
        <el-table-column prop="nowDivid" label="本次可分" width="150"></el-table-column>
        <el-table-column prop="nowDividU" label="本次分红折U" width="160"></el-table-column>
        <el-table-column prop="createdTime" label="创建时间" :formatter="dateFormat" width="160"></el-table-column>
        <el-table-column label="操作" width="140">
          <template slot-scope="scope">
            <el-button @click="update(scope.row)" type="primary">修改数值</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 30px"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
      </el-pagination>
    </el-card>
    <el-dialog
      :visible.sync="dataUpdate"
      width="500px"
      title="修改数值">
      <div class="dateUpdate">
        <div>
          <span>预计磨损率</span> <el-input oninput="value=value.replace(/[^0-9.]/g,'')" v-model="abrasionRatio"></el-input>
        </div>
        <div>
          <span>其他</span> <el-input oninput="value=value.replace(/[^0-9.]/g,'')" v-model="other"></el-input>
        </div>
        <div>
          <span>特殊充值</span> <el-input oninput="value=value.replace(/[^0-9.]/g,'')" v-model="specialDeposit"></el-input>
        </div>
        <div>
          <span>汇率</span> <el-input oninput="value=value.replace(/[^0-9.]/g,'')" v-model="exchangeRate"></el-input>
        </div>
        <div class="btn">
          <el-button type="primary" @click="confirm">确认</el-button>
          <el-button @click="clear">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="coinSettUpda"
     width='700px'
      title='币种设置修改'>
      <div class="coinsettinng">
        <table  v-if="settingary.length>0">
          <tr>
            <td>*币种</td>
            <td>其他</td>
            <td>预计磨损率</td>
            <td>特殊充值</td>
            <td>操作</td>
          </tr>
          <tr v-for="(item) in settingary" :key="item.id">
            <td>
              <el-select v-model="item.coin" filterable clearable placeholder="请选择币种">
                <el-option
                  v-for="item in coinTypes"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input oninput="value=value.replace(/[^0-9.]/g,'')"   v-model="item.other" style="width:100%"></el-input>
            </td>
            <td>
              <el-input oninput="value=value.replace(/[^0-9.]/g,'')" v-model="item.abrasionRatio" style="width:100%"></el-input>
            </td>
            <td>
              <el-input oninput="value=value.replace(/[^0-9.]/g,'')" v-model="item.specialDeposit" style="width:100%"></el-input>
            </td>
            <td style="width:100px">
              <div @click="dele(item)" href="#">删除</div>
            </td>
          </tr>
         
        </table>
        <div class="noData" v-else>当前暂未设置币种，请去新增币种。</div>
         <div class="btn">
          <el-button type="primary" @click="save">确定</el-button>
          <el-button @click="clear">取消</el-button>
        </div>
      </div>
      
    </el-dialog>
    <el-dialog
      :visible.sync="coinadd"
     width='700px'
      title='新增币种'>
      <div class="coinsettinng">
        <table>
          <tr>
            <td>*币种</td>
            <td>其他</td>
            <td>预计磨损率</td>
            <td>特殊充值</td>
          </tr>
          <tr v-for="(item) in newary" :key="item.id">
            <td>
              <el-select v-model="item.coin" filterable clearable placeholder="请选择币种">
                <el-option
                  v-for="item in coinTypes"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input oninput="value=value.replace(/[^0-9.]/g,'')" v-model="item.other" style="width:100%"></el-input>
            </td>
            <td>
              <el-input oninput="value=value.replace(/[^0-9.]/g,'')" v-model="item.abrasionRatio" style="width:100%"></el-input>
            </td>
            <td>
              <el-input oninput="value=value.replace(/[^0-9.]/g,'')" v-model="item.specialDeposit" style="width:100%"></el-input>
            </td>
          </tr>
        </table>
         <div class="btn">
          <el-button type="primary" @click="coinSave">保存</el-button>
          <el-button @click="clear">取消</el-button>
        </div>
      </div>
      
    </el-dialog>
  </div>
</template>

<script>
import './store';
import api from './api';
import { mapActions, mapState } from 'vuex';
import moment from 'moment';
export default {
  name: 'TransferPsiSettle',
  data() {
    return {
       pickerOptions0: {
        disabledDate (time) {
          let curDate = (new Date()).getTime();
          let three = 14 * 24 *3600 * 1000;
          let threeMonths = curDate - three;
          return time.getTime() > Date.now() || time.getTime() < threeMonths
        }
      },
      seleCoin:'',
      coinquery:[],
      datePicker:[new Date(new Date().toLocaleDateString()).getTime(),new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1],
      dataList:[],
      dataUpdate:false,
      coinadd:false,
      coinSettUpda:false,
      input:'',
      settingary:[],
      newary:[{id:'',other:null,coin:'',abrasionRatio:null,specialDeposit:null}],
      page:1,
      size:10,
      total:10,
      abrasionRatio:null,
      other:null,
      specialDeposit:null,
      exchangeRate:null,
      id:null
    };
  },
  computed: {
    ...mapState('transferPsiSettle', [ 'coinTypes'])
  },
  methods: {
    ...mapActions('transferPsiSettle', ['getCoinTypes']),
    
    search(){
      this.getList()
    },
    empty(){
      this.seleCoin = '';
      this.datePicker = [new Date(new Date().toLocaleDateString()).getTime(),new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1]
    },
    update(data){
      this.abrasionRatio = data.abrasionRatio;
      this.other = data.other;
      this.specialDeposit = data.specialDeposit;
      this.exchangeRate = data.exchangeRate;
      this.id = data.id;
      this.dataUpdate = true;
    },
    dele(res){
      console.log(res)
      let data = {id:res.id}
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        api.currencyConfigdel(data).then(res=>{
          this.coinSettlist()
          this.$message({
            type: 'success',
            message: `删除成功`
          });
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
    getList(){
      let data = {
        beginTime:this.datePicker[0],
        endTime:this.datePicker[1],
        coin:this.seleCoin,
        page:this.page,
        size:this.size,
      }
      api.psipage(data).then(res=>{
        this.dataList = res.data.records;
        this.total = res.data.total;
      })
    },
    handleSizeChange(val) {
        this.size = val;
        this.getList();
    },
    handleCurrentChange(val) {
        this.page = val;
        this.getList();
    },
    exportData(){
      let data = {
        beginTime:this.datePicker[0],
        coin:this.seleCoin,
        endTime:this.datePicker[1],
      }
      api.export(data).then((response) => {
          const fileName = "PSI分红结算统计表.xlsx";
          const blob = new Blob([response], {type: 'application/vnd.ms-excel'});
          if ('download' in document.createElement('a')) {
              const link = document.createElement('a');
              link.download = fileName;
              link.style.display = 'none';
              link.href = URL.createObjectURL(blob);
              document.body.appendChild(link);
              link.click();
              URL.revokeObjectURL(link.href);
          } else {
              navigator.msSaveBlob(blob, fileName);
          }
      });
    },
    confirm(){
      let data = {
        abrasionRatio:this.abrasionRatio,
        other:this.other,
        id:this.id,
        specialDeposit:this.specialDeposit,
        exchangeRate:this.exchangeRate
      }
      api.updateStatistics(data).then(res=>{
        this.$message.success("修改成功!")
        this.getList()
        this.dataUpdate = false;
      })
      
    },
    clear(){
      this.dataUpdate = false;
      this.coinadd = false;

      this.coinSettUpda = false;
    },
    coinAddBtn(){
      this.coinadd = true;
      this.newary = [{id:'',other:null,coin:'',abrasionRatio:null,specialDeposit:null}];
    },
    coinBtn(){
      this.coinSettUpda = true;
      this.coinSettlist()
    },
    coinSettlist(){
      api.coinSetting().then(({ data }) => {
        this.settingary = data
        let ary = []
        data.map(item=>{
          ary.push(item.coin)
        })
        this.coinquery = [...ary]
      });
    },
    save(){
      if(this.settingary == 0){
        this.coinSettUpda =false
        return
      }
      for(let i in this.settingary){
        if(this.settingary[i].coin == ''){
          this.$message.warning('请选择币种！');
          return;
        }
      }
      let ary = this.settingary
      api.batchEdit(ary).then(res=>{
        if(res.code == 0){
          this.$message.success("修改成功!")
          this.getList()
          this.coinSettUpda =false
        }
      })
    },
    coinSave(){
      if(this.newary[0].coin == ''){
        this.$message.warning("请选择币种！")
        return
      }
      api.batchEdit(this.newary).then(res=>{
        if(res.code == 0){
          this.$message.success("添加成功!")
          this.coinadd =false
        }
      })
    },
     dateFormat(row, column) {
          return moment(row.createdTime).format("YYYY-MM-DD HH:mm:ss");
      },
  },
  created() {
    // this.coinSet()
    this.coinSettlist()
    this.getList()
    this.getCoinTypes()
  }
};
</script>

<style lang="less" scoped>
.el-input {
  width: 300px;
  margin-right: 10px;
}
.tb-wrapper {
  margin: 20px 0px;
}
.pager-wrapper {
  text-align: right;
}

.dateUpdate{
  >div{
    margin-bottom: 10px;
    >span{
      margin:0 20px;
      width: 70px;
      display: inline-block;
    }
  }
  .btn{
    margin-top: 20px;
    text-align: center;
    >button{
      width: 100px;
    }
  }
}
.coinsettinng{
  table{
    border-left: 1px solid #e8e8e8;
    border-spacing: 0;
    >tr:first-child{
      background: #f5f5f6;
    }
    >tr{
      td{
        border-bottom: 1px solid #e8e8e8;
        border-right: 1px solid #e8e8e8;
        text-align: center;
        >div{
          cursor: pointer;
          color: #3e6dee;
        }
      }
    }

  }
  .noData{
    text-align: center;
    font-size: 16px;
    color: #333333;
  }
  .btn{
    text-align: center;
    margin-top: 20px;
    button{
      width: 100px;
    }
  }
}
</style>
